import CtaPreferenceManager, { CtaBannerOptions } from "./CtaPreferenceManager";

export default CtaPreferenceManager;

export { CtaPreferenceManager, CtaBannerOptions };
